import React from 'react';
// import PropTypes from 'prop-types';
import { NavigationBar } from '../../organisms/shared/navigationBar/NavigationBar';
import Header from '../../organisms/shared/header/Header';
import Footer from '../../organisms/shared/footer/Footer';
import { Breadcrumbs } from '../../molecules/shared/breadcrumbs/Breadcrumbs';
import { IntroGuideSection } from '../../organisms/category/introGuideSection/IntroGuideSection';
import { SystemList } from '../../organisms/category/systemList/SystemList';
import { InfoSection } from '../../organisms/category/infoSection/InfoSection';
import { CollapseSection } from '../../organisms/category/collapseSection/CollapseSection';
// import InfoPopup from '../../molecules/shared/infoPopup/InfoPopup';
import { getDataByType } from '../../../utils/utils';

export const Category = ({
  hero,
  breadcrumbs,
  sections,
  t,
  locale,
  menu,
  footer,
  siteUrls,
  location,
  search,
  trackOutboundLink,
}) => {
  const sectionOne = getDataByType(sections, 'sectionOne');
  const cardsData = getDataByType(sections, 'sectionSystemList');
  const sectionThree = getDataByType(sections, 'sectionThree');
  const sectionCollapse = getDataByType(sections, 'sectionAccordion');

  return (
    <div className="bg-primary-50 overflow-x-hidden">
      <NavigationBar
        data={menu}
        location={location}
        locale={locale}
        search={search}
        t={t}
      />
      <Header headerText={hero.title} minHeight="350px" />
      <main className="relative">
        <Breadcrumbs
          levels={breadcrumbs}
          infoText={t('legal.category.text')}
          // infoContent={
          //   <InfoPopup
          //     description={t('legal.category.text')}
          //     displayDirection="left"
          //   />
          // }
        />
        <IntroGuideSection section={sectionOne} t={t} />
        <SystemList
          section={cardsData}
          showRelatedCategories
          showSubCategories
          locale={locale}
          trackOutboundLink={trackOutboundLink}
          t={t}
        />
        <InfoSection section={sectionThree} />
        {sectionCollapse.componentData.length > 0 && (
          <CollapseSection section={sectionCollapse} />
        )}
      </main>
      <Footer data={footer} siteUrls={siteUrls} />
    </div>
  );
};

Category.propTypes = {
  // hero: PropTypes.object,
  // sections: PropTypes.array,
};
